import React, { Component, useEffect, useState } from 'react';


const socialshareConfigurationDefault = [
    {
        'provider': 'buffer',
        'conf': {
            'url': '',
            'text': '',
            'via':false,
            'media': '',
            'trigger': 'click',
            'popupHeight': 600,
            'popupWidth': 500
        }
    },
    {
        'provider': 'flipboard',
        'conf': {
            'url': '',
            'text': '',
            'trigger': 'click',
            'popupHeight': 600,
            'popupWidth': 500
        }
    },
    {
        'provider': 'wordpress',
        'conf': {
            'url': '',
            'text': '',
            'media': '',
            'trigger': 'click',
            'popupHeight': 600,
            'popupWidth': 500
        }
    },
    {
        'provider': 'sms',
        'conf': {
            'url': '',
            'text': '',
            'to': '',
            'trigger': 'click'
        }
    },
    {
        'provider': 'skype',
        'conf': {
            'url': '',
            'text': '',
            'trigger': 'click',
            'popupHeight': 600,
            'popupWidth': 500
        }
    },
    {
        'provider': 'weibo',
        'conf': {
            'url': '',
            'text': '',
            'trigger': 'click',
            'popupHeight': 600,
            'popupWidth': 500
        }
    },
    {
        'provider': 'facebook-messenger',
        'conf': {
          'url': ''
        }
    }];



const CustomShare = ({ className, variant, children, config, ...props }) => {
    const [configuration, setConfiguration] = useState();
    useEffect(() => {
        const socialConfig = socialshareConfigurationDefault.find(v => v.provider === variant);
        if (socialConfig) {
            setConfiguration(socialConfig)
        }
    }, [variant])


    const generateLink = (socialConfig) => {
        const attrs = {...socialConfig.conf, ...config};
        switch (socialConfig.provider) {
            case 'skype': {
                var urlString = 'https://web.skype.com/share?source=button&url=' + encodeURIComponent(attrs.url || window.location.href);

                if (attrs.text) {
                    urlString += '&text=' + encodeURIComponent(attrs.text);
                }
                window.open(
                    urlString
                    , 'Skype', 'toolbar=0,status=0,resizable=yes,width=' + attrs.popupWidth + ',height=' + attrs.popupHeight
                    + ',top=' + (window.innerHeight - attrs.popupHeight) / 2 + ',left=' + (window.innerWidth - attrs.popupWidth) / 2);
                break;
            }
            case 'sms': {
                var body = encodeURIComponent(attrs.text.replace('%', ''))
                    , toPhoneNumber = attrs.to || ''
                    , urlString;

                if (attrs.url) {
                    body += ' '+encodeURIComponent(attrs.url);
                }
                const el = document.createElement('a')
                urlString = 'sms:' + toPhoneNumber + '?&body=' + body;
                el.href = urlString;
                el.target = '_blank';
                el.click();
                el.remove();
                break;
            }
            case 'buffer': {
                var urlString = 'https://bufferapp.com/add?';

                if (attrs.text) {
                    urlString += 'text=' + encodeURIComponent(attrs.text);
                }

                if (attrs.via) {
                    urlString += '&via=' + encodeURIComponent(attrs.via);
                }

                if (attrs.media) {
                    urlString += '&picture=' + encodeURIComponent(attrs.media);
                }
                urlString += '&url=' + encodeURIComponent(attrs.url || window.location.href);

                window.open(
                    urlString,
                    'Buffer', 'toolbar=0,status=0,resizable=yes,width=' + attrs.popupWidth + ',height=' + attrs.popupHeight
                    + ',top=' + (window.innerHeight - attrs.popupHeight) / 2 + ',left=' + (window.innerWidth - attrs.popupWidth) / 2);

                break;
            }
            case 'wordpress': {
                var urlString = 'http://wordpress.com/press-this.php?';

                if (attrs.text) {
                    urlString += 't=' + encodeURIComponent(attrs.text) + '&';
                }
                if (attrs.media) {
                    urlString += 'i=' + encodeURIComponent(attrs.media) + '&';
                }
                urlString += 'u=' + encodeURIComponent(attrs.url || window.location.href);

                window.open(
                    urlString,
                    'Wordpress', 'toolbar=0,status=0,resizable=yes,width=' + attrs.popupWidth + ',height=' + attrs.popupHeight
                    + ',top=' + (window.innerHeight - attrs.popupHeight) / 2 + ',left=' + (window.innerWidth - attrs.popupWidth) / 2);
                break;
            }
            case 'flipboard': {

                var urlString = 'https://share.flipboard.com/bookmarklet/popout?v=2&';

                if (attrs.text) {
                    urlString += 'title=' + encodeURIComponent(attrs.text) + '&';
                }

                //default to the current page if a URL isn't specified
                urlString += 'url=' + encodeURIComponent(attrs.url || window.location.href);

                window.open(
                    urlString,
                    'Flipboard', 'toolbar=0,status=0,resizable=yes,width=' + attrs.popupWidth + ',height=' + attrs.popupHeight
                    + ',top=' + (window.innerHeight - attrs.popupHeight) / 2 + ',left=' + (window.innerWidth - attrs.popupWidth) / 2);

                break;
            }
            case 'facebook-messenger': {

                const href = 'fb-messenger://share?link=' + encodeURIComponent(attrs.url || window.location.href);
                const link = document.createElement('a');
                link.href = href;
                link.target = '_top';
                document.body.append(link)
                link.click();
                link.remove();
                break;
            }
            default: {
                return;
            }
        }
    }

    return (
        <div className={className}  onClick={() => generateLink(configuration)}>
            <div style={{borderRadius:50, padding:6,display:'flex'}}>{children}</div>
        </div>
    )
}

export default CustomShare;
